import $api from "../Api";
import ResponseChecker from "../Middlewares/ResponseChecker";
import { defaultMessages } from "../enums/responseMessages.js";
import Endpoints from "../Endpoints";

/**
 * @param {{ params?: object, query?: { name?: string, isActive?: boolean, tagGroupId?: string, page?: number, limit?: number } }} [option]
 */
export const GetAll = async (option) => {
  const response = await $api.get(Endpoints.Tag.GetAll(option));
  return ResponseChecker(defaultMessages, response);
};

/**
 * @param {{ name: string, description?: string, color?: string, isActive?: boolean, tagGroupIds?: string[] }} form
 */
export const Create = async (form) => {
  const response = await $api.post(Endpoints.Tag.Create(), form);
  return ResponseChecker(defaultMessages, response);
};

/**
 * @param {{ params: { id: string }, query?: object }} option
 */
export const GetById = async (option) => {
  const response = await $api.get(Endpoints.Tag.GetById(option));
  return ResponseChecker(defaultMessages, response);
};

/**
 * @param {{ id: string, name: string, description?: string, color?: string, isActive?: boolean, tagGroupIds?: string[] }} form
 */
export const Update = async (form) => {
  const { id, ...body } = form;
  const response = await $api.put(
    Endpoints.Tag.Update({ params: { id } }),
    body
  );
  return ResponseChecker(defaultMessages, response);
};

/**
 * @param {{ params: { id: string }, query?: object }} option
 */
export const Delete = async (option) => {
  const response = await $api.delete(Endpoints.Tag.Delete(option));
  return ResponseChecker(defaultMessages, response);
};

export default {
  GetAll,
  Create,
  GetById,
  Update,
  Delete,
};
